module.exports = "<ul><li>Lavazza A Modo Mio capsule coffee machine</li><li>Hansgrohe Raindance 3jet adjustable power shower</li><li>Comfy chair to work or relax in</li><li>Powerful hairdryer & full length mirror</li><li>A choice of firm or soft hypoallergenic pillows</li><li>Plenty of power and USB charging throughout</li><li>Relaxing ambient LED mood lighting</li><li>Spacious desk with multiple charging points, desk light and swivel chair</li><li>Dreamlight colour scheme & blackout curtains for a restful night’s sleep</li></ul>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/hotels/hotel-room/hotel-room-details/hotel-super-room-amenities-description.html
// module id = 3212
// module chunks = 0